import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "107",
    height: "109",
    viewBox: "0 0 107 109",
    fill: "none",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M35.6 54.1L107 37.1V0.0999985H70L35.6 54.1Z" fill="#FF3300" /> <path d="M0.200012 53.5C0.200012 57.9 0.700014 62.2 1.80001 66.3L35.6 54.1L1.50001 41.8C0.700011 45.6 0.200012 49.5 0.200012 53.5Z" fill="#FF3300" /> <path d="M12.8 19L35.6 54.1L46.1 0.599998C32.8 2.5 21.1 9.2 12.8 19Z" fill="#FF3300" /> <path d="M35.6 54.1L107 71.1V108.2H70L35.6 54.1Z" fill="#FF3300" /> <path d="M12.8 89.2L35.6 54.1L46.1 107.6C32.8 105.8 21.1 99 12.8 89.2Z" fill="#FF3300" />' }
  })
);